import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { RadioButtonGroups } from "../../../../Constant";
import { DynamicRadioButtonGroup } from "./DynamicRadioButtonGroup";
import { StaticRadioButtonGroup } from "./StaticRadioButtonGroup";
import { RADIO_BUTTON_GROUP } from "../../../../Data/Buttons/ButtonGroup";

const RadioButtonGroup = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={RadioButtonGroups} span={RADIO_BUTTON_GROUP} />
        <CardBody className="btn-group-showcase">
          <Row>
            <StaticRadioButtonGroup />
            <DynamicRadioButtonGroup />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RadioButtonGroup;
